__turbopack_context__.v({
  "control": "card-top-panel-module-scss-module__icJFea__control",
  "regular": "card-top-panel-module-scss-module__icJFea__regular",
  "tags": "card-top-panel-module-scss-module__icJFea__tags",
  "wide": "card-top-panel-module-scss-module__icJFea__wide",
  "wideOnMobile": "card-top-panel-module-scss-module__icJFea__wideOnMobile",
});
